<template>
  <div>
    <!--基本信息-->
    <div class="basicInfo">
      <!--头部信息-->
      <div class="header">
        <div @click="backShop">{{ back }}返回</div>
        <div>基本信息</div>
        <div>
          <div class="shouldKnow" @click="know()">入驻须知</div>
        </div>
      </div>
      <!--表单-->
      <div class="formList">
        <div class="first">
          <div class="title">名称</div>
          <div class="inputContent">
            <input v-model="shopName" placeholder="请输入名称(必填)" />
          </div>
        </div>
        <div>
          <div class="title">联系人</div>
          <div class="inputContent">
            <input v-model="shopManger" placeholder="请输入联系人" />
          </div>
        </div>
        <div>
          <div class="title">联系电话</div>
          <div class="inputContent">
            <input v-model="shopPhone" placeholder="限填单个手机号" />
          </div>
        </div>
        <div>
          <div class="title">联系QQ</div>
          <div class="inputContent">
            <input v-model="shopQQ" placeholder="请输入联系QQ" />
          </div>
        </div>
        <div>
          <div class="title">地址</div>
          <div class="inputContent">
            <input v-model="shopAddress" placeholder="请输入地址" />
          </div>
        </div>
        <div>
          <div class="title">主营信息</div>
          <div class="inputContent">
            <input v-model="shopSaleInfo" placeholder="请输入主营信息" />
          </div>
        </div>
      </div>
      <div class="shopSimpleInfo">
        <div>企业简介</div>
        <div>
          <textarea v-model="shopShortInfo"></textarea>
        </div>
      </div>
      <div class="shopLogo">
        <div>企业logo（正方形）</div>
        <div style="display: flex; flex-wrap: wrap; margin-top: 12.5px">
          <div v-if="preshopLogo.length > 0" class="wrap-load sia c-c">
            <van-icon
              name="close"
              class="sia-close"
              @click="clearShopLogo(0)"
            />
            <img
              v-for="(item, index) in preshopLogo"
              :key="index"
              :src="item"
            />
          </div>
          <div v-else class="wrap-load sia c-c">
            <img
              src="../assets/images/images/addImage.png"
              @click="addShopLogo"
            />
          </div>
        </div>
      </div>
      <div class="shopLogo">
        <div>微信二维码</div>
        <div style="display: flex; flex-wrap: wrap; margin-top: 12.5px">
          <div v-if="preshopImageCode.length > 0" class="wrap-load sia c-c">
            <van-icon
              name="close"
              class="sia-close"
              @click="clearShopImageCode(0)"
            />
            <img
              v-for="(item, index) in preshopImageCode"
              :key="index"
              :src="item"
            />
          </div>
          <div v-else class="wrap-load sia c-c">
            <img
              src="../assets/images/images/addImage.png"
              @click="addShopImageCode"
            />
          </div>
        </div>
      </div>
      <div class="shopLogo">
        <div>形象照片（小于9张）</div>
        <div style="display: flex; flex-wrap: wrap; margin-top: 12.5px">
          <template v-if="preintroduceImages.length > 0">
            <div
              class="wrap-load sia c-c"
              v-for="(item, index) in preintroduceImages"
              :key="index"
            >
              <van-icon
                name="close"
                class="sia-close"
                @click="clearaddFaceImages(index)"
              />
              <img :src="item" />
            </div>
          </template>
          <div v-if="preintroduceImages.length < 9" class="wrap-load sia c-c">
            <img
              src="../assets/images/images/addImage.png"
              @click="addFaceImages"
            />
          </div>
        </div>
      </div>
      <!--开通店铺会员-->
      <div class="openShopVip">
        <div
          v-for="(item, index) in prePayInfo"
          :key="index"
          class="price"
          :style="nowSelect == item.id ? 'border:1px solid #882784;' : ''"
          @click="choosePrice(item.id)"
        >
          <div>{{ item.name }}</div>
          <div>
            <span>￥</span><span>{{ item.fee / 100 }}</span>
          </div>
          <div>
            {{
              item.days == "30"
                ? "一个月"
                : item.days == "180"
                ? "六个月"
                : item.days == "360"
                ? "一年"
                : ""
            }}
          </div>
          <div style="font-size: 10px">
            送{{
              item.days == "30"
                ? "一个月"
                : item.days == "180"
                ? "六个月"
                : item.days == "360"
                ? "一年"
                : ""
            }}刷新VIP
          </div>
          <img
            v-if="nowSelect == item.id"
            style="z-index: 99; width: 15px; height: 15px"
            src="../assets/images/images/gouxuan.png"
            alt=""
          />
          <img
            v-if="nowSelect == item.id"
            src="../assets/images/images/leftTopSelect.png"
            alt=""
          />
        </div>
      </div>
      <!--开通须知-->
      <div class="mustKnow">
        <div v-if="hasRead" @click="changeReadStatus">
          <img src="../assets/images/images/select.png" alt="" />
        </div>
        <div v-else @click="changeReadStatus">
          <img src="../assets/images/images/closeSelect.png" alt="" />
        </div>
        <div>我已阅读入驻须知，并同意相关条款</div>
      </div>
      <div class="submitInfo" @click="confirmAddShop">
        <div>确认续费</div>
      </div>
    </div>

    <van-popup class="reset-pop" v-model="showTips">
      <div v-html="tips.content"></div>
    </van-popup>
    <div
      @click="closeTips"
      v-if="showTips"
      style="
        z-index: 9999;
        margin: 0 auto;
        position: fixed;
        bottom: 5%;
        left: 0;
        right: 0;
        width: 30px;
        height: 30px;
      "
    >
      <img src="../assets/images/images/close.png" alt />
    </div>
    <!--图片加载中-->
    <div
      v-show="showLoadingPic"
      style="
        z-index: 99;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #000;
        opacity: 0.6;
      "
    >
      <div
        style="
          z-index: 100;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 50%;
          height: 50%;
        "
      >
        <van-loading size="24px" vertical color="rgb(137, 39, 133)"
          >图片上传中...</van-loading
        >
      </div>
    </div>
  </div>
</template>
<script>
let me;
import axios from "axios";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
import HomeTab from "../components/HomeTab2";
export default {
  name: "updateShopInfo",
  data() {
    return {
      back: "<<",
      showLoadingPic: false,
      showTips: false,
      tips: "",
      screenHeight: "",
      shopName: "", //店铺名称
      shopManger: "", //店铺联系人
      shopPhone: "", //联系电话
      shopQQ: "", //联系QQ
      shopAddress: "", //店铺地址
      shopSaleInfo: "", //主营信息
      shopShortInfo: "", //店铺简介
      preshopLogo: [], //预展示logo
      shopLogo: [], //店铺logo
      preshopImageCode: [], //预展示二维码
      shopImageCode: "", //店铺二维码
      preintroduceImages: [], //预展示形象图片
      introduceImages: [], //宣传数组
      update: false, //当前是否为更新店铺
      shopId: "", //店铺id，用于查询

      nowSelect: 4, //当前选中的价格
      hasRead: true, //是否
      prePayInfo: [], //支付信息
    };
  },
  components: {
    HomeTab,
  },
  methods: {
    //获取支付信息
    getPrePayInfo() {
      getData("/vip/refresh-fee")
        .then((res) => {
          me.prePayInfo = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //切换阅读状态
    changeReadStatus() {
      this.hasRead = !this.hasRead;
    },
    //选择价格
    choosePrice(index) {
      this.nowSelect = index;
    },
    know() {
      getData("/article/agreement?option_id=4").then((res) => {
        this.tips = res.data;
        this.showTips = true;
        // this.$store.commit('UPDATEATBINDEX',{tag: -1});
        // this.$store.commit('UPDATEARTICLEDETAIL',{articleDetail: res.data});
        // this.$router.push({ name: "articleDetail", params: {
        //   detail: res.data
        // }});
      });
    },
    backShop() {
      this.$router.back(-1);
    },
    onRead(file) {
      //4.上传用户选中的图片
      let formData = new FormData();
      formData.append("thumb", file);
      let url = "";
      url = "http://api.jfc.jfbst.com/api/v2/upload";
      axios({
        url: url,
        processData: false, // 告诉axios不要去处理发送的数据(重要参数)
        contentType: false, // 告诉axios不要去设置Content-Type请求头
        method: "post",
        data: formData,
      }).then((res) => {
        me.showLoadingPic = false;
        this.shopLogo.push(res.data.data.src);
      });
    },
    onReadImageCode(file) {
      //4.上传用户选中的图片
      let formData = new FormData();
      formData.append("thumb", file);
      let url = "";
      url = "http://api.jfc.jfbst.com/api/v2/upload";
      axios({
        url: url,
        processData: false, // 告诉axios不要去处理发送的数据(重要参数)
        contentType: false, // 告诉axios不要去设置Content-Type请求头
        method: "post",
        data: formData,
      }).then((res) => {
        me.showLoadingPic = false;
        this.shopImageCode = res.data.data.src;
      });
    },
    onReadFace(file,datas) {
      let formData = new FormData();
      formData.append("thumb", file);
      let url = "";
      url = "http://api.jfc.jfbst.com/api/v2/upload";
      axios({
        url: url,
        processData: false, // 告诉axios不要去处理发送的数据(重要参数)
        contentType: false, // 告诉axios不要去设置Content-Type请求头
        method: "post",
        data: formData,
      }).then((res) => {
        me.showLoadingPic = false;
        me.introduceImages.push(res.data.data.src);
        let aa = datas;
        aa.shift();
        if (aa.length > 0) {
          me.getTrueImageA(aa);
        }
      });
    },
    dataURLtoFile(dataurl, filename) {
      //3.base64转文件
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    getLogo(data) {
      //获取logo
      wx.getLocalImgData({
        localId: data,
        success: function (res) {
          var localData = res.localData;
          if (localData.indexOf("data:image") != 0) {
            //判断是否有这样的头部
            localData = "data:image/jpeg;base64," + localData;
          }
          localData = localData
            .replace(/\r|\n/g, "")
            .replace("data:image/jgp", "data:image/jpeg");
          me.showLoadingPic = true;
          me.preshopLogo.push(localData);
          let date = Date.parse(new Date());
          let a = me.dataURLtoFile(localData, date);
          me.onRead(a);
        },
        fail: function (err) {},
      });
    },
    getImageCode(data) {
      //获取二维码
      wx.getLocalImgData({
        localId: data,
        success: function (res) {
          var localData = res.localData;
          if (localData.indexOf("data:image") != 0) {
            //判断是否有这样的头部
            localData = "data:image/jpeg;base64," + localData;
          }
          localData = localData
            .replace(/\r|\n/g, "")
            .replace("data:image/jgp", "data:image/jpeg");
          me.showLoadingPic = true;
          me.preshopImageCode.push(localData);
          let date = Date.parse(new Date());
          let a = me.dataURLtoFile(localData, date);
          me.onReadImageCode(a);
        },
        fail: function (err) {},
      });
    },
    addShopLogo() {
      //添加店铺logo
      wx.chooseImage({
          count: 1,
          sizeType: ["original", "compressed"],
          sourceType: ["album", "camera"],
          success: function (res) {
            me.getLogo(res.localIds[0]);
          },
        });
      
    },
    addShopImageCode() {
      //添加店铺二维码
      wx.chooseImage({
          count: 1,
          sizeType: ["original", "compressed"],
          sourceType: ["album", "camera"],
          success: function (res) {
            me.getImageCode(res.localIds[0]);
          },
        });
    },
    async getTrueImageA(datas) {
      //2.调用wx.getLocalImgData获取展示图片链接地址
        await wx.getLocalImgData({
          localId: datas[0],
          success: function (res) {
            var localData = res.localData;
            if (localData.indexOf("data:image") != 0) {
              //判断是否有这样的头部
              localData = "data:image/jpeg;base64," + localData;
            }
            localData = localData
              .replace(/\r|\n/g, "")
              .replace("data:image/jgp", "data:image/jpeg");
            me.showLoadingPic = true;
            me.preintroduceImages.push(localData);
            let date = Date.parse(new Date());
            let a = me.dataURLtoFile(localData, date);
            me.onReadFace(a,datas);
          },
          fail: function (err) {},
        });
    },
    addFaceImages() {
      //添加形象图片
      let canChooseImgNum = 9 - me.preintroduceImages.length;
      if (canChooseImgNum <= 0) {
        this.$toast("图片最多只能上传9张哦~");
        return;
      }
      wx.chooseImage({
          count: canChooseImgNum,
          sizeType: ["original", "compressed"],
          sourceType: ["album", "camera"],
          success: function (res) {
            me.getTrueImageA(res.localIds);
          },
        });
    },
    clearShopLogo(index) {
      //清除店铺logo
      this.preshopLogo.splice(index, 1);
      this.shopLogo.splice(index, 1);
    },
    clearShopImageCode(index) {
      //清除店铺二维码
      this.preshopImageCode.splice(index, 1);
      this.shopImageCode = "";
    },
    clearaddFaceImages(index) {
      //清除形象图片
      this.preintroduceImages.splice(index, 1);
      this.introduceImages.splice(index, 1);
    },
    getConfigData() {
      //获取配置数据
      let pathname = encodeURIComponent(window.location.pathname);
      let search = encodeURIComponent(window.location.search);
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var iPad = u.indexOf("iPad") > -1;
      var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
      let anURL =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        window.location.search; //安卓地址
      let iosURL = this.$store.state.jumpUrl; //ios地址
      let result = "";
      if (isAndroid) {
        result = anURL;
      }
      if (isiOS || iPad || iPhone) {
        result = iosURL;
      }
      //this.message=result;
      result = encodeURIComponent(result);
      getData("/oauth/credential/jssdk?debug=1&url=" + result).then((res) => {
        wx.config({
          //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ["chooseImage", "uploadImage"], // 必填，需要使用的JS接口列表，所有JS接口列表见微信公众平台附录
        });
      });
    },
    //确认支付
    prePayMoney() {
      postData("/payment/order/create", {
        trade_type: "mp",
        plan_id: me.nowSelect,
      })
        .then((res) => {
          me.onBridgeReady(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //调起微信支付
    onBridgeReady(msg) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", msg, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          //支付完成提交页面信息
          me.submitInfo();
        }
      });
    },
    confirmAddShop() {
      if (me.shopName == "") {
        this.$toast("请填写完信息后提交");
        return;
      }
      if (me.shopPhone == "" || !/^1[3456789]\d{9}$/.test(me.shopPhone)) {
        this.$toast("请填写正确的手机号");
        return;
      }
      if (!me.hasRead) {
        this.$toast("请先阅读入驻须知");
        return;
      }
      me.prePayMoney();
    },
    //提交页面信息
    submitInfo() {
      let formData = new FormData();
      for (let a = 0; a < this.introduceImages.length; a++) {
        formData.append("thumb[]", this.introduceImages[a]);
      }

      formData.append("shop_id", me.shopId);
      formData.append("name", me.shopName);
      formData.append("logo", me.shopLogo[0] || "");
      formData.append("contact", me.shopManger);
      formData.append("phone", me.shopPhone);
      formData.append("mobile", me.shopPhone);
      formData.append("qq", me.shopQQ);
      formData.append("weixin", me.shopImageCode);
      formData.append("address", me.shopAddress);
      formData.append("business", me.shopSaleInfo);
      formData.append("intro", me.shopShortInfo);
      postData("/shop/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token:
            localStorage.getItem("token") != ""
              ? localStorage.getItem("token")
              : "123456",
        },
      }).then((res) => {
        if (res.code == "0") {
          me.data = {
            screenHeight: "",
            shopName: "", //店铺名称
            shopManger: "", //店铺联系人
            shopPhone: "", //联系电话
            shopQQ: "", //联系QQ
            shopAddress: "", //店铺地址
            shopSaleInfo: "", //主营信息
            shopShortInfo: "", //店铺简介
            preshopLogo: [], //预展示logo
            shopLogo: [], //店铺logo
            preshopImageCode: [], //预展示二维码
            shopImageCode: "", //店铺二维码
            preintroduceImages: [], //预展示形象图片
            introduceImages: [], //宣传数组
            update: false, //当前是否为更新店铺
            shopId: "", //店铺id，用于查询
          };
          me.$router.replace({
            name: "result",
          });
        } else {
          this.$toast(res.msg);
        }
      });
    },
    closeTips() {
      this.showTips = false;
    },
    searchShopBaseInfo() {
      getData("/shop", { shop_id: me.shopId }).then((res) => {
        if (res.code == "0") {
          me.shopName = res.data.name;
          me.shopManger = res.data.contact;
          me.shopPhone = res.data.phone;
          me.shopQQ = res.data.qq;
          me.shopAddress = res.data.address;
          me.shopSaleInfo = res.data.business;
          me.shopShortInfo = res.data.intro;
          if (res.data.logo_url != "") {
            me.preshopLogo.push(res.data.logo_url); //预展示logo
            me.shopLogo.push(res.data.logo); //上传的logo
          }
          if (res.data.weixin_url != "") {
            me.preshopImageCode.push(res.data.weixin_url); //预展示二维码
            me.shopImageCode = res.data.weixin; //上传的微信图片
          }

          me.preintroduceImages = res.data.thumbs.map((item) => {
            return item.path_url;
          });
          me.introduceImages = res.data.thumbs.map((item) => {
            return item.path;
          });
        }
      });
    },
  },
  mounted() {
    me = this;
    me.getConfigData();
    me.getPrePayInfo();
    me.update = true;
    me.shopId = me.$route.query.id;
    me.searchShopBaseInfo();
    me.screenHeight = window.screen.availHeight;
  },
};
</script>
<style scoped>
.reset-pop {
  width: 80%;
  max-height: 70% !important;
  border-radius: 3px;
  padding: 10px;
}
.sia {
  position: relative;
}
.sia-close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 7px;
  background: #fff;
  border-radius: 50%;
}
.wrap-load {
  width: 88.5px;
  height: 88.5px;
  border: 1px dashed rgb(220, 220, 220);
  margin-top: 5px;
  margin-right: 5px;
}
.wrap-load i {
  font-size: 23px;
  color: rgb(220, 220, 220);
}
.submitInfo {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 37px;
}
.submitInfo > div {
  width: 331px;
  height: 41px;
  border-radius: 5px;
  background-color: #892785;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  color: #fff;
}
.addImage {
  width: 88.5px;
  height: 88.5px;
  margin-top: 12.5px;
}
.basicInfo {
  overflow-y: scroll;
}
.header {
  display: flex;
  width: 100%;
  height: 45px;
  background-color: #892785;
  align-items: center;
  color: #fff;
}
.header > div {
  width: 0;
  flex-grow: 1;
}
.header > div:nth-child(1) {
  font-size: 15px;
}
.header > div:nth-child(2) {
  font-size: 18px;
}
.header > div:nth-child(3) {
  display: flex;
  justify-content: center;
}
.shouldKnow {
  width: 68px;
  height: 23px;
  border: 1px solid #fff;
  font-size: 15px;
  border-radius: 5px;
}
.first {
  margin-top: 10px;
  border-top: 1px solid #e6e6e6;
}
.formList > div {
  display: flex;
  width: 100%;
  height: 41px;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
}
.title {
  width: 75px;
  padding-left: 16px;
  text-align: left;
  font-size: 15px;
  color: #4d4d4d;
}
.inputContent {
  width: calc(100%-91px);
}
.inputContent input {
  border: none;
}
.shopSimpleInfo,
.shopLogo {
  margin: 12px 16px 0 16px;
}
.shopSimpleInfo > div,
.shopLogo > div {
  text-align: left;
}
.shopSimpleInfo > div:nth-child(2) textarea {
  width: 338px;
  height: 83px;
  margin-top: 8.5px;
}
.openShopVip {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border-top: 1px solid #b2b2b2;
}
.price {
  width: 95px;
  height: 100px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
}
.price > div:nth-child(1) {
  font-size: 13px;
  font-weight: bold;
  margin-top: 5px;
}
.price > div:nth-child(2) span:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
}
.price > div:nth-child(2) span:nth-child(2) {
  font-size: 30px;
  font-weight: bold;
  color: #892785;
}
.price > div:nth-child(3) {
  font-size: 13px;
  font-weight: bold;
}
.price > div:nth-child(4) {
  color: #892785;
}
.price img {
  width: 30px;
  height: 30px;
  position: absolute;
  right: -1.5px;
  top: -2px;
}
.mustKnow {
  display: flex;
  font-size: 13px;
  margin-top: 10px;
  margin-left: 20px;
  align-items: center;
}
.mustKnow > div {
  display: flex;
  align-items: center;
}
.mustKnow img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
</style>